import { isInternalCompany } from 'shared/helpers/matchers/checkCompanyType';

const termsAccess = (user, access) =>
  access.terms.list && !isInternalCompany(user.relatedCompany.companyType);

export { termsAccess };
